export const decomActions = [
  // User Actions
  {
    value: 'vaultGmailExport',
    label: 'Gmail Export',
    delayedAction: false,
    groupType: 'Vault',
    description: `Export a decommissioned user's Gmail to Google Vault by selecting an existing matter or creating a new one.`,
  },
  {
    value: 'vaultCalendarExport',
    label: 'Calendar Export',
    delayedAction: false,
    groupType: 'Vault',
    description: `Export a decommissioned user's Google Calendar to Google Vault by selecting an existing matter or creating a new one.`,
  },
  {
    value: 'vaultChatExport',
    label: 'Chat Export',
    delayedAction: false,
    groupType: 'Vault',
    description: `Export a decommissioned user's Google Chat to Google Vault by selecting an existing matter or creating a new one.`,
  },
  {
    value: 'vaultDriveExport',
    label: 'Drive Export',
    delayedAction: false,
    groupType: 'Vault',
    description: `Export a decommissioned user's Google Drive to Google Vault by selecting an existing matter or creating a new one.`,
  },
  {
    value: 'vaultGeminiExport',
    label: 'Gemini Export',
    delayedAction: false,
    groupType: 'Vault',
    description: `Export a decommissioned user's Gemini information to Google Vault by selecting an existing matter or creating a new one.`,
  },
  {
    value: 'vaultGroupsExport',
    label: 'Groups Export',
    delayedAction: false,
    groupType: 'Vault',
    description: `Export a decommissioned user's Google Groups to Google Vault by selecting an existing matter or creating a new one.`,
  },
  {
    value: 'EmailDump',
    label: 'Gmail Export',
    delayedAction: false,
    groupType: 'Gmail',
    description: `This action creates a full export that can be downloaded under "Import / Export > Gmail Export". Enterprise users have the ability to specify a user or manager that will receive the export in their Google Drive with a newly created folder named "gPanel Decommissioning: {Policy Name} Decommissioning User: {Decommissioned User}".`,
  },
  {
    value: 'setForwarding',
    label: 'Set Forwarding',
    delayedAction: false,
    groupType: 'Gmail',
    description: `This action creates a Gmail forward for incoming mail of the decommissioned user. The forwarding user can be a specified user/group or the user's manager defined in the user's profile.`,
  },
  {
    value: 'addDelegate',
    label: 'Add Delegate',
    delayedAction: false,
    groupType: 'Gmail',
    description: `This action creates a Gmail delegate for the decommissioned user's Gmail. The delegate user can be a specified user or the user's manager defined in the user's profile.  If an expiration is set, the delegate will be removed X number of days after the delegate is created, where X is defined by the configuration.`,
  },
  {
    value: 'delegateToRelation',
    label: 'Delegate to Relation',
    delayedAction: false,
    groupType: 'Gmail',
    description: `This action creates a Gmail delegate for the decommissioned user's Gmail. The delegate user can be specified by a relation defined in the user's profile.  If an expiration is set, the delegate will be removed X number of days after the delegate is created, where X is defined by the configuration.`,
  },
  {
    value: 'removeEmailAliases',
    label: 'Remove Email Aliases',
    delayedAction: false,
    groupType: 'Gmail',
    description: `This action removes all Gmail aliases from the decommissioned user.`,
  },
  {
    value: 'removeForwardingAddresses',
    label: 'Remove Forwarding Addresses',
    delayedAction: false,
    groupType: 'Gmail',
    description: `This action removes all Gmail forwarding addresses from the decommissioned user.`,
  },
  {
    value: 'vacationResponder',
    label: 'Vacation Responder',
    delayedAction: false,
    groupType: 'User',
    description: `This action sets a Gmail vacation responder message for the decommissioned user.`,
  },
  {
    value: 'sendEmail',
    label: 'Send Email',
    delayedAction: false,
    groupType: 'User',
    description: `This action sends an email to all specified users/groups provided as well as the user's manager defined in the user's profile if selected.`,
  },
  {
    value: 'ReassignNicknames',
    label: 'Reassign Aliases',
    delayedAction: false,
    groupType: 'User',
    description: `This action transfers all Gmail aliases from the decommissioned user to a specified user or the user's manager defined in the user's profile.`,
  },
  {
    value: 'UserNameChange',
    label: 'User Name Change',
    delayedAction: false,
    groupType: 'User',
    description: `This action adds a specified prefix or suffix to the decommissioned users primary email address.`,
  },
  {
    value: 'ResetPassword',
    label: 'Reset Password',
    delayedAction: false,
    groupType: 'User',
    description: `This action resets the password for the decommissioned user to a randomized password or a predefined password with an option to force a password reset on next login.  Also gives the ability to send the new password of the user to the notification user of the policy.`,
  },
  {
    value: 'UserOrgChange',
    label: 'User Org Change',
    delayedAction: false,
    groupType: 'User',
    description: `This action changes the decommissioned user's organization unit.`,
  },
  {
    value: 'RemoveFromAllGroups',
    label: 'Remove From All Groups',
    delayedAction: false,
    groupType: 'User',
    description: `This action removes the decommissioned user from all groups.`,
  },
  {
    value: 'RevokeThirdPartyApps',
    label: 'Revoke Third Party Apps',
    delayedAction: false,
    groupType: 'User',
    description: `This action removes the decommissioned user's third party applications.`,
  },
  {
    value: 'signOutUser',
    label: 'Sign Out User',
    delayedAction: false,
    groupType: 'User',
    description: `This action signs out the decommissioned user from all web and device sessions and resets their sign-in cookies.`,
  },
  {
    value: 'removeAllLicenses',
    label: 'Remove Google Assigned Licenses',
    delayedAction: false,
    groupType: 'User',
    description: `This action removes the decommissioned user from all Google assigned licenses.  The user will be assigned a Google Cloud Identity license, or a Google Archive license by default, based on the domain's settings.`,
  },
  {
    value: 'deleteASPS',
    label: 'Delete ASPs',
    delayedAction: false,
    groupType: 'User',
    description: `This action removes all application specific passwords from the decommissioned user.`,
  },
  {
    value: 'deleteSharedContact',
    label: 'Remove from Shared Contacts',
    delayedAction: false,
    groupType: 'User',
    description: `This action removes the decommissioned user from shared contacts.`,
  },
  {
    value: 'deleteUser',
    label: 'Delete User',
    delayedAction: true,
    groupType: 'User',
    description: `This action deletes the decommissioned user, with the ability to require that all Decommissioning logs be acknowledged prior to the deletion occuring.`,
  },
  {
    value: 'suspendUser',
    label: 'Suspend User',
    delayedAction: false,
    groupType: 'User',
    description: `This action suspends the decommissioned user.`,
  },
  {
    value: 'unsuspendUser',
    label: 'Unsuspend User',
    delayedAction: false,
    groupType: 'User',
    description: `This action unsuspends the decommissioned user.`,
  },
  {
    value: 'archiveUser',
    label: 'Archive User',
    delayedAction: false,
    groupType: 'User',
    description: `This action archives the decommissioned user.`,
  },
  {
    value: 'disableTwoFactor',
    label: 'Disable Two Factor',
    delayedAction: false,
    groupType: 'User',
    description: `This action disables Two Factor verification for the decommissioned user.`,
  },
  {
    value: 'hideFromDirectory',
    label: 'Hide From Directory',
    delayedAction: false,
    groupType: 'User',
    description: `This action removes the decommissioned user from the Global Address list.`,
  },
  {
    value: 'removeSlackChannels',
    label: 'Remove Slack Channels',
    delayedAction: false,
    groupType: 'User',
    description: `This action removes the decommissioned user from all Slack channels they are members of.`,
  },

  // Calendar Actions
  {
    value: 'ClearPrimaryCalendar',
    label: 'Clear Primary Calendar',
    delayedAction: false,
    groupType: 'Calendars',
    description: `This action clears all events from the decommissioned user's primary calendar.`,
  },
  {
    value: 'releaseResourceCalendar',
    label: 'Release Resource Calendar Events',
    delayedAction: false,
    groupType: 'Calendars',
    description: `This action will remove all events booked against any Resource Calendar of the domain and decommissioned user.`,
  },
  {
    value: 'transfercals',
    label: 'Transfer Calendars',
    delayedAction: false,
    groupType: 'Calendars',
    description: `This action transfers the decommissioned user's primary calendar to another user. The destination user can be a specified user or the user's manager defined in the user's profile.`,
  },

  // Mobile Actions
  {
    value: 'wipeMobileDevices',
    label: 'Mobile Wipe',
    delayedAction: false,
    groupType: 'Mobile Management',
    description:
      'This action wipes the mobile devices for the decommissioned user.',
  },
  {
    value: 'wipeMobileAccounts',
    label: 'Mobile Account Wipe',
    delayedAction: false,
    groupType: 'Mobile Management',
    description: `This action wipes the mobile accounts for the decommissioned user.`,
  },
  {
    value: 'blockMobileDevices',
    label: 'Mobile Block',
    delayedAction: false,
    groupType: 'Mobile Management',
    description: `This action blocks the mobile devices for the decommissioned user.`,
  },
  {
    value: 'deleteMobileDevices',
    label: 'Mobile Delete',
    delayedAction: false,
    groupType: 'Mobile Management',
    description: `This action removes all mobile devices from the decommissioned user.`,
  },

  // Document Actions
  {
    value: 'transferDocs',
    label: 'Transfer Docs',
    delayedAction: false,
    groupType: 'Documents',
    description: `This action transfers all folders and files to another user. The destination user can be a specified user or the user's manager defined in the user's profile.`,
  },
  {
    value: 'docsSharedExternallyReport',
    label: 'Docs Shared Externally Report',
    delayedAction: false,
    groupType: 'Documents',
    description: `This action generates a report of the decommissioned user's externally shared folders and files. The destination user can be a specified user or the user's manager defined in the user's profile.`,
  },
  {
    value: 'actSharedExternallyReportMyDrive',
    label: 'Activities Shared Externally (My Drive)',
    delayedAction: false,
    groupType: 'Documents',
    description: `This action generates a report of the decommissioned user's activites where folders or files were shared externally from the user's Drive. The destination user can be a specified user or the user's manager defined in the user's profile.`,
  },
  {
    value: 'actSharedExternallyReportSharedDrive',
    label: 'Activities Shared Externally (Shared Drive)',
    delayedAction: false,
    groupType: 'Documents',
    description: `This action generates a report of the decommissioned user's activites where folders or files were shared externally from the user's Shared Drives. The destination user can be a specified user or the user's manager defined in the user's profile.`,
  },
  {
    value: 'actSharedPubliclyReportMyDrive',
    label: 'Activities Shared Externally from My Drive (Public)',
    delayedAction: false,
    groupType: 'Documents',
    description: `This action generates a report of the decommissioned user's publicly shared folders and files. The destination user can be a specified user or the user's manager defined in the user's profile.`,
  },
  {
    value: 'actSharedPubliclyReportSharedDrives',
    label: 'Activities Shared Externally from Shared Drives (Public)',
    delayedAction: false,
    groupType: 'Documents',
    description: `This action generates a report of the decommissioned user's activites where folders or files were shared publicly from the user's Shared Drives. The destination user can be a specified user or the user's manager defined in the user's profile.`,
  },
  {
    value: 'removeExternalShares',
    label: 'Remove External Shares',
    delayedAction: false,
    groupType: 'Documents',
    description: `This action removes all external shares from the decommissioned users's Drive and generates a report which can be created under a specified user or the user's manager defined in the user's profile.`,
  },
  {
    value: 'removeUserFromShares',
    label: 'Remove User from Shares',
    delayedAction: false,
    groupType: 'Drive',
    description: `The Remove User from Shares Operation removes the decommissioned users from all shared files and folders. This will not remove shares inherited from Shared Drives.`,
  },
  {
    value: 'removeUsersShares',
    label: "Remove User's Shares",
    delayedAction: false,
    groupType: 'Drive',
    description: `The Remove User's Shares Operation removes all the users from the decommisioned user's shared files and folders.`,
  },
  {
    value: 'RemoveFromAllSharedDrive',
    label: 'Remove From All Shared Drive',
    delayedAction: false,
    groupType: 'Documents',
    description: `This action removes the decommissioned user from all Shared Drives.`,
  },
];

export const isVaultExportAction = (
  actionType: string | undefined
): boolean => {
  if (!actionType) return false;
  return decomActions.some(
    (a) => a.value === actionType && a.groupType === 'Vault'
  );
};
